(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var compileJade = require('browjadify-compile')
  , infoPopoverTemplate = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"popover ec-popover-auto\"><div class=\"arrow\"></div><h3 class=\"popover-title\"></h3><div class=\"popover-content\"></div></div>");;return buf.join("");
}
  , extend = require('lodash.assign')

module.exports = function (selector, template, options) {
  var formContext = this
  options = options || {}

  function bindEvents (selectize) {
    selectize.$wrapper.on('click', '.item', function (e) {
      var $target = $(e.target)
        , popover = $target.data('bs.popover')
        , _id = $target.data('value')
        , data = selectize.options[_id]

      if (!popover) {
        $target.popover(
          { trigger: 'manual'
          , html: true
          , placement: 'auto bottom top'
          , container: '.js-main-container'
          , viewport: '.js-popover-viewport'
          , template: infoPopoverTemplate()
          , content: $(template({ data: data }))
        })
      }

      $target.popover('toggle')
    })

    selectize.on('item_remove', function () {
      // Ensure orphaned popovers don't stay visible
      formContext.$('.popover').popover('hide')
    })
  }

  formContext.$(selector).selectize(
    extend(
      { valueField: '_id'
      , labelField: 'name'
      , searchField: 'name'
      , create: false
      , persist: false
      , maxItems: null
      , onInitialize: function () {
          bindEvents(this)
        }
      }
    , options
    )
  )

  // only allow one popover to be open at time
  $(document).on('click', function (e) {
    var $target = $(e.target)
      , selects = formContext.$(selector).filter('.selectize-control')
      , $popover = $target.closest('.popover')
      , isPopover = $popover.length !== 0

    // Prevent hiding popover if the click occurs within it
    if (!isPopover) {
      selects
        .find('.item')
        .not('.active')
        .filter(function (i, el) {
          return typeof $(el).data('bs.popover') !== 'undefined'
        })
        .popover('hide')
    }
  })
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/info-selectize-delegate.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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